import { SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { MutableRefObject, useCallback, useState } from 'react';

import { useSelectionCountContext } from 'core/states';

interface IProps {
  gridRef: MutableRefObject<AgGridReact>;
  customOnSelectionChanged?: (event: SelectionChangedEvent) => void;
}

export const useAgGridSelection = ({ gridRef, customOnSelectionChanged = null }: IProps) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const { setSelectionCount } = useSelectionCountContext();

  const onSelectionChanged = useCallback(
    (event: SelectionChangedEvent) => {
      if (!gridRef?.current?.api) {
        return;
      }

      const gridSelectedRows = gridRef.current.api.getSelectedRows() || [];

      setSelectedRows(gridSelectedRows);
      setSelectionCount(gridSelectedRows?.length);

      customOnSelectionChanged && customOnSelectionChanged(event);
    },
    [customOnSelectionChanged, gridRef, setSelectionCount]
  );

  const deselectAllRows = useCallback(() => {
    if (!gridRef?.current?.api) {
      return;
    }

    const selectedRows = gridRef.current.api.getSelectedRows() || [];

    if (!selectedRows.length) {
      return;
    }

    gridRef.current.api.deselectAll();
  }, [gridRef]);

  return {
    selectedRows,
    selectedRowsIds: selectedRows.map((row) => row.id),
    onSelectionChanged,
    deselectAllRows,
  };
};
